import React, { useContext, useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Context } from '../../../context/app-context'
import { usePlayContext } from '../../../hooks/useContextPlay'
import { LayoutModal } from '../../templates/layout-modal/layout-modal'
import Button from '../../atoms/button/button'
import CompetitionService from '../../../shared-campaign/services/competition'
import {
  LOCALE,
  concourseId,
  gameId,
  isThreeLivesCountry,
} from '../../../constants/activity-constants'
import useMediaQuery from '../../../utils/useMediaQuery'
import userSessionStorage from '../../../utils/userSessionStorage'
import GameServices from '../../../services/game-service'
import useTimeout from '../../../hooks/useTimeOut'
import './modalKeys.scss'
import { triggerTag } from '../../../utils/taggeo'

type statusMsg = 'error' | 'success'
interface IErrorMsg {
  status: statusMsg
  message: string
}

const ModalKeys = ({ close }: { close: () => void }) => {
  const [isLoadingPoints, setIsLoadingPoints] = useState(false)
  const [errorMessage, setErrorMessage] = useState<IErrorMsg>()
  const [myKey, setMyKey] = useState('')
  const isMobile = useMediaQuery()
  const session = new userSessionStorage()
  const { participations, firstPromotionalKey } = usePlayContext()

  const { timeOut, clearTimeOut } = useTimeout()

  const showUps = participations >= 1

  const handleErrorMessage = (status: statusMsg, message: string) => {
    setErrorMessage({
      status: status,
      message: message,
    })
    setTimeout(() => {
      setErrorMessage(undefined)
    }, 6000)
  }

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    if (isLoadingPoints) {
      return null
    }
    e.preventDefault()

    if (myKey === '') {
      handleErrorMessage('error', 'Ingresa primero una clave')
      return
    }

    if (myKey.length < 10) {
      handleErrorMessage('error', 'La clave debe ser mínimo de 10 caracteres')
      return
    }

    if (myKey.length === 10) {
      setIsLoadingPoints(true)
      setErrorMessage(undefined)
      let redeemRes = await CompetitionService.postRedeemKeyWithoutPoints(
        concourseId,
        {
          activity: 'v-school',
          key: { code: myKey },
          country: parseInt(process.env.COUNTRY_CODE!),
        }
      )

      if (redeemRes.status === 200) {
        triggerTag(showUps ? '14A' : '13A', { label: 'Enviar' })
        let tokenId = session.getToken()?.idToken
        const config = {
          headers: tokenId
            ? {
                Authorization: tokenId,
              }
            : undefined,
        }
        let totalLives = 3
        if (LOCALE === 'es-CO') {
          if (firstPromotionalKey) {
            totalLives = participations > 1 ? 3 : 5
          } else {
            totalLives = participations === 0 ? 5 : 3
          }
        }
        const payload = {
          totalLives,
          code: myKey,
        }

        GameServices.postLive(gameId!, payload, config).then(
          async (res: any) => {
            if (res.status === 200) {
              //handleDataLayer()
              setIsLoadingPoints(false)
              handleErrorMessage('success', res.userMessage)
              await timeOut(1000)
              clearTimeOut()
              setMyKey('')
              close()
            } else {
              //handleDataLayer(true)
              handleErrorMessage('error', res.userMessage)
              setIsLoadingPoints(false)
              setMyKey('')
            }
          }
        )
      } else {
        //handleDataLayer(true)
        handleErrorMessage('error', redeemRes.userMessage)
        setIsLoadingPoints(false)
        setMyKey('')
        return
      }
    }

    if (myKey.length > 10) {
      //clave promocional de 12
      setIsLoadingPoints(true)
      setErrorMessage(undefined)
      let tokenId = session.getToken()?.idToken
      const config = {
        headers: tokenId
          ? {
              Authorization: tokenId,
            }
          : undefined,
      }

      let promotionalKeyRes = await GameServices.postPromotionalKey(
        {
          competitionId: concourseId,
          key: { code: myKey },
        },
        config
      )

      if (promotionalKeyRes.status === 200) {
        triggerTag(showUps ? '14A' : '13A', { label: 'Enviar' })
        let tokenId = session.getToken()?.idToken
        const config = {
          headers: tokenId
            ? {
                Authorization: tokenId,
              }
            : undefined,
        }

        const payload = {
          totalLives: isThreeLivesCountry ? 5 : 10,
          code: myKey,
        }

        GameServices.postLive(gameId!, payload, config).then(
          async (res: any) => {
            if (res.status === 200) {
              //handleDataLayer()
              setIsLoadingPoints(false)
              handleErrorMessage('success', res.userMessage)
              await timeOut(1000)
              clearTimeOut()
              setMyKey('')
              close()
            } else {
              //handleDataLayer(true)
              handleErrorMessage('error', res.userMessage)
              setIsLoadingPoints(false)
              setMyKey('')
            }
          }
        )
      } else {
        // handleDataLayer(true)
        handleErrorMessage('error', promotionalKeyRes.userMessage)
        setIsLoadingPoints(false)
        setMyKey('')
        return
      }
    }
    // si llega aqui es porque fue exitoso....
  }
  return (
    <LayoutModal
      childrenBG={showUps ? BgUps() : BgWelcome(isMobile)}
      close={close}
      className="f-modalKeys"
    >
      <>
        <h2 className={showUps ? '--h2Blue' : ''}>
          {showUps
            ? '¡Ups! Se acabaron tus vidas'
            : '¡Bienvenida a V-School Nosotras!'}
        </h2>
        {showUps ? (
          <p>
            <span>¡Registra más claves!</span> Recuerda que puedes usar:
            <br />
            <br />
            <b>Las claves personales de cualquier producto Nosotras,</b> y
            recibe 3 vidas, para activar los juegos
          </p>
        ) : (
          <p>
            Ingresa las claves personal de cualquier producto Nosotras y recibe
            3 vidas para activar los juegos.
            <br />
            <br />
            Recuerda que debes estar muy atenta, porque en la visita de Nosotras
            a tu colegio o en tu correo, recibirás una de estas claves
            especiales.
            <br />
            <br />
            ¡Podrás usarla una sola vez!
          </p>
        )}
        <form onSubmit={onSubmit}>
          <input
            type="text"
            placeholder="Ingresa tu clave"
            id="keys"
            name="keys"
            value={myKey}
            maxLength={12}
            onChange={e => {
              setMyKey(e.target.value)
            }}
          />
          {errorMessage?.message && (
            <span
              className={`f-message ${errorMessage.status === 'error' ? '--error' : '--success'}`}
            >
              {errorMessage.message}
            </span>
          )}

          <Button
            title="Enviar"
            type="submit"
            loading={isLoadingPoints}
            className="f-modalKeys-button"
          >
            Enviar
          </Button>
        </form>
      </>
    </LayoutModal>
  )
}

export default ModalKeys

const productImg = (
  <StaticImage
    src="../../../assets/images/modals/keys.png"
    alt="producto nosotras"
    title="producto nosotras"
    width={360}
    placeholder="blurred"
  />
)

const BgWelcome = (isMobile: boolean | null) => (
  <div className="f-modalKeys-background --bgCenter">
    <div className="f-modalKeys-background__product">
      <div className="f-modalKeys-background__product--wrapper">
        <div className="f-modalKeys-background__product--rhombus"></div>
        {productImg}
      </div>
    </div>
    {!isMobile && (
      <div className="f-modalKeys-background__logo">
        <StaticImage
          src="../../../assets/images/play/logo-play.png"
          alt="logo v-school"
          title="logo v-school"
          width={400}
          placeholder="blurred"
        />
      </div>
    )}
  </div>
)

const BgUps = () => (
  <div className="f-modalKeys-background">
    <div className="f-modalKeys-background__locker">
      <StaticImage
        src="../../../assets/images/modals/locker.png"
        alt="Locker de escuela"
        title="Locker de escuela"
        width={400}
        placeholder="blurred"
      />
    </div>
    <div className="f-modalKeys-background__sad">
      <StaticImage
        src="../../../assets/images/modals/sad.png"
        alt="Locker de escuela"
        title="Locker de escuela"
        width={350}
        placeholder="blurred"
      />
    </div>
    <div className="f-modalKeys-background__productSad">{productImg}</div>
    <div className="f-modalKeys-background__floor"></div>
  </div>
)
